<!-- 底部组件 -->
<template>
<div>
  <div class="foot" :class="$store.state.sizeType">
    <div class="top">
      <img src="../assets/logo.png">
      <div class="list list1">
        <div class="title1">网站导航</div>
        <div class="title2">Contact us</div>
        <div class="xian"></div>
        <div class="nav">
          <div @click="goPage(item)" class="one" v-for="(item,index) in navs" :key="index">{{ item.name }}</div>
        </div>
        
      </div>
      <div class="list list2">
        <div class="title1">联系我们</div>
        <div class="title2">Contact us</div>
        <div class="xian"></div>
        <div class="one">地址：上海市长宁区安顺路139弄2号楼4楼</div>
        <div class="one">邮编：200000 <span v-if="$store.state.sizeType === 'phone'" style="margin-left: 0.3rem;">公司网址：Juvamedical.com</span></div>
        <div class="one" v-if="$store.state.sizeType === 'pc'">公司网址：Juvamedical.com</div>
        <div class="one">邮箱：BIZ@JUVACHINA.COM</div>
      </div>
      <div class="list list3">
        <div class="title1">友情链接</div>
        <div class="title2">Friendly link</div>
        <div class="xian"></div>
        <div class="nav">
          <div class="one" @click="goOut('https://endymed.com/')">Endymed官方网站</div>
          <div class="one" @click="goOut('https://bioxis.com/')">BIOXIS官网</div>
          <div class="one" @click="goOut('https://www.3healthcare.com/')">昊海生科官方网站</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <span class="foot_ga" @click="goOut('https://beian.mps.gov.cn/#/query/webSearch')"><img src="../assets/foot-ga.png"> 公安备案号: 津公网安备12011602300253号</span> 
      <span @click="goOut('https://beian.miit.gov.cn/#/Integrated/index')">京ICP备17055495号-1</span> 
      Copyright © 2018 Ouhua Med. com 保留所有权利
    </div>
  </div>

  <div class="phone" v-if="$store.state.sizeType=='phone'">
    
  </div>
</div>
</template>

<script>
export default {
  name: 'foot',
  inject: ['reload'],
  props: {
    
  },
  data() {
    return {
      language: {},// 文案
      navs: [],
    };
  },
  methods: {
    // 进入其他页面
    goPage: function(item,index){
      this.$router.push({path: item.path});
    },
    goOut: function(url){
      window.open(url, '_blank')
    }
  },
  mounted() {
    this.navs = this.$language[this.$store.state.pageType].foot.navs;
  }
};
</script>

<style scoped lang='scss'>
  .foot{
    background: #F7F7F7;

    .top{
      display: flex;
      padding: 65px calc(50% - 650px) 45px calc(50% - 650px);
      justify-content: space-between;
      border-bottom: 1px solid #E8E8E8;

      img{
        width: 134px;
        height: 70px;
      }

      .list{
        .title1{
          font-weight: 600;
          font-size: 16px;
          color: #303030;
          margin-bottom: 5px;
        }

        .title2{
          font-weight: 600;
          font-size: 12px;
          color: #303030;
          margin-bottom: 20px;
        }

        .xian{
          width: 16px;
          height: 3px;
          background: #CCCCCC;
          margin-bottom: 30px;
        }

        .one{
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          margin-bottom: 15px;

          &:last-child{
            margin-bottom: 0;
          }
        }

        &.list1{
          .one{
            cursor: pointer;
          }
        }

        &.list3{
          .one{
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }
    .bottom{
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      // opacity: 0.4;
      height: 48px;
      text-align: center;
      line-height: 48px;

      span{
        cursor: pointer;

        &.foot_ga{
          margin-right: 10px;

          img{
            display: inline-block;
            position: relative;
            top: 3px;
          }
        }

        &:hover{
          color: #000;
        }
      }
    }

    &.phone{
      .top{
        flex-direction: column;
        padding: 0 0.3rem;

        img{
          display: none;
        }

        .list{
          font-size: 0.28rem;
          border-bottom: 0.01rem solid #E8E8E8;
          padding: 0.4rem 0;

          &:last-child{
            border: none;
          }

          .title1{
            margin-bottom: 0.05rem;
          }

          .title2{
            margin-bottom: 0.35rem;
          }

          .xian{
            width: 0.26rem;
            height: 0.05rem;
            margin-bottom: 0.25rem;
          }

          .nav{
            display: flex;
            justify-content: space-between;
          }

          &.list1{
            .one{
              margin-bottom: 0;
            }
          }

          &.list3{
            .one{
              margin-bottom: 0;
            }
          }
        }
      }

      .bottom{
        font-size: 0.18rem;
        height: 0.85rem;
        line-height: 0.4rem;

        span{
          &.foot_ga{
            margin-right: 0;
            display: block;
            
            img{
              display: inline-block;
              position: relative;
              top: 3px;
            }
          }
        }
      }
    }
  }

  
</style>



// WEBPACK FOOTER //
// src/components/foot.vue